import { Link } from "react-router-dom";


const testLinks = [
  { to: "/hollandtest", label: "Профессиональные типы" },
  { to: "/jovashtest", label: "Профессиональные интересы" },
  { to: "/trudmotivtest", label: "Мотивация на деятельность" },
  { to: "/orgtest", label: "Оргтест" },
  { to: "/orgtestruk", label: "Оргтест (руководитель)" },
  { to: "/russianTest", label: "Тест по русскому языку" },
  { to: "/form", label: "Анкета №1" },
  { to: "/directorForm", label: "Анкета №2" },
  { to: "/zags", label: "Анкета №3" },
  { to: "/kddm", label: "Анкета КДДМ" },
  { to: "/komandaizmeneniy", label: "Анкета команды изменений" },
  { to: "/cgt", label: "Анкета ЦГТ" },
  { to: "/questionnarieKai", label: "Анкета №4" },
  { to: "/questionnarie", label: "Анкета №5" },
  { to: "/managerForm", label: "Анкета руководителя" },
  { to: "/cityDevelopment", label: "Анкета развитие города" },
  { to: "/reserveForm", label: "Анкета для резервистов" },
  { to: "/anotherReserveForm", label: "Другая анкета для резервистов" },
  { to: "/mot", label: "Мотивационный опрос" },
  { to: "/motivationProfile", label: "Мотивационный профиль" },
  { to: "/activityAnalytics", label: "Анализ активности" },
  { to: "/experienceAnalysis", label: "Анализ деятельности" },
];

const AllTestsPage = () => {
  return (
    <div className="max-w-full sm:max-w-7xl mx-auto mt-8 p-6 bg-white rounded shadow">
      <h1 className="text-2xl font-bold mb-6 text-center text-gray-800">
        Все доступные тесты и анкеты
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {testLinks.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className="block p-4 text-base border border-gray-200 rounded-lg shadow-sm hover:shadow-md hover:border-blue-500 transition-all duration-200 text-blue-700 hover:text-blue-900 font-medium"
          >
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AllTestsPage;
